import { gql } from '@apollo/client';

export const FETCH_CATEGORIE_SERVIZI = gql`
  query fetchCategorieServizi(
    $where: Categorie_serviziWhereInput
    $limit: Int!
  ) {
    categorie_servizis(first: $limit, where: $where) {
      edges {
        node {
          objectId
          org_pointer {
            objectId
            nome
          }
          nome_categoria
          attivo
          order
          servizi_offerti_default_pointer {
            objectId
            nome
          }
        }
      }
    }
  }
`;
